import { Link } from "react-router-dom";
import { fmtDate } from "@/components/manual/icons";

export const Changelog = ({ versions, sections }) => {
  const title = (id) => sections.find((s) => s.id === id)?.title;
  return (
    <div className="animate-rise" data-testid="manual-changelog">
      <h2 className="font-heading text-2xl font-semibold text-slate-900">Novità e versioni</h2>
      <p className="mt-1 text-sm text-slate-500">Tutti gli aggiornamenti del portale, dal più recente.</p>
      <ol className="mt-6 space-y-6 border-l-2 border-slate-100 pl-6">
        {versions.map((v, i) => (
          <li key={v.version} className="relative" data-testid={`changelog-${v.version}`}>
            <span className={`absolute -left-[31px] top-1 h-3.5 w-3.5 rounded-full border-2 border-white ${i === 0 ? "bg-teal-500" : "bg-slate-300"}`} />
            <div className="flex flex-wrap items-center gap-2">
              <span className="font-mono text-sm font-semibold text-slate-900">v{v.version}</span>
              {i === 0 && <span className="rounded-full bg-teal-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-teal-700">Versione corrente</span>}
              <span className="text-xs text-slate-400">{fmtDate(v.date)}</span>
            </div>
            <div className="mt-0.5 font-heading text-base font-semibold text-slate-800">{v.title}</div>
            <ul className="mt-2 space-y-1.5">
              {v.items.filter((it) => title(it.section)).map((it, k) => (
                <li key={k} className="flex gap-2 text-sm text-slate-700">
                  <Link to={`/manuale/${it.section}`} className="shrink-0 rounded bg-blue-50 px-1.5 py-0.5 text-xs font-medium text-blue-700 hover:bg-blue-100">{title(it.section)}</Link>
                  <span>{it.text}</span>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ol>
    </div>
  );
};
